"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
/**
 *
 * @param firestore
 * @returns Get analysis from parametros/userapp/analysis
 */
async function getAnalysis(firestore) {
    const path = "parametros/userapp/analysis";
    const analysisRef = (0, firestore_1.collection)(firestore, path);
    let analysis;
    const deliveryArray = [];
    try {
        analysis = await (0, firestore_1.getDocs)(analysisRef);
    }
    catch (err) {
        throw new Error(`${err}`);
    }
    analysis.forEach(object => deliveryArray.push(object.data()));
    return deliveryArray;
}
exports.default = getAnalysis;
